import { Image, Typography, message } from "antd";
import Logo from "../../../assets/images/logo.svg";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import NetworkCall from "network/networkCall";
import Request from "network/request";
const { Title, Paragraph } = Typography;

export default function DeclinedRequest() {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const [statusChange, setstatusChange] = useState(false);
  let res = null;

  const declinedRequest = async () => {
    try {
      const body = {
        email: queryParams.get("Email").replace(/ /g, "+"),
        diaryId: parseInt(queryParams.get("diaryId")),
        statusTypeId: parseInt(queryParams.get("StatusTypeId")),
        securityKey: queryParams.get("SecurityKey"),
      };
      res = await NetworkCall.fetch(Request.declinedDiaryInvite(body), false);
      queryParams.delete("Email");
      queryParams.delete("diaryId");
      queryParams.delete("SecurityKey");
      queryParams.delete("StatusTypeId");

      const updatedQueryString = queryParams.toString();

      window.history.replaceState(null, null, `?${updatedQueryString}`);
    } catch (error) {
      setstatusChange(true);
      queryParams.delete("Email");
      queryParams.delete("diaryId");
      queryParams.delete("SecurityKey");
      queryParams.delete("StatusTypeId");
    }
  };

  useEffect(() => {
    queryParams.get("diaryId") && declinedRequest();
  }, []);

  return (
    <>
      {!statusChange ? (
        queryParams.get("StatusTypeId") === "2" ? (
          <div className="decline-request-wrap">
            <div className="decline-request-card">
              <Image className="mb-3" src={Logo} preview={false} />
              <Title level={4}>Invitation Declined</Title>
              <Paragraph className="decline-text">
                We believe in the transformative power of journaling to mend
                relationships and find resolution. While it's okay if you  are
                not ready for  it  now, we encourage you to consider the
                potential benefit.
              </Paragraph>
              <Paragraph className="decline-text">
                Our platform provides a safe and structured space for open
                communication and understanding. The journey towards resolution
                can be a powerful and enriching experience, and we're here to
                support you every step of the way. Feel free to explore our app
                and its features.
              </Paragraph>
              <a
                href="https://resolveit.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="ant-btn ant-btn-primary ant-btn-lg"
              >
                Explore Now
              </a>{" "}
            </div>
          </div>
        ) : (
          <div className="block-request-wrapper">
            <div className="br-wrap">
              <div className="content-wrap">
                <Image preview={false} className="logo" src={Logo} />
                <Title level={4}>User Blocked</Title>
                <p>
                  You have blocked this user, and you will not receive any more
                  invitations from them.
                </p>
              </div>
              <div className="footer">
                ResolveIT, LLC 2010 N Church Street #33368, Dealware United
                States
              </div>
            </div>
          </div>
        )
      ) : (
        <div className="block-request-wrapper">
          <div className="br-wrap">
            <div className="content-wrap">
              <Image preview={false} className="logo" src={Logo} />
              <Title level={4}>Status Updated</Title>
              <p>It seems both users continue the journal</p>
            </div>
            <div className="footer">
              ResolveIT, LLC 2010 N Church Street #33368, Dealware United States
            </div>
          </div>
        </div>
      )}
    </>
  );
}
